import { z } from 'zod';
import { VariantCheckAnswerSchema } from '../survey/survey.schema';
/**
 * Step Variant Response Schema
 * One co-performer's Variant Check answer about a step recording: "genau so",
 * "anders" (+ description) or "mache ich nicht".
 *
 * Its own document rather than fields on the survey row, because the answer is a
 * captured fact in itself — it must stay readable when the classic survey around
 * it is never finished.
 *
 * Immutable, carrying ADR 0022's rule: there is no update path, only a
 * re-request asks again. `requestGeneration` is what makes that safe — a
 * response records the generation of the survey row it answered, so a response
 * still in flight when the step is re-requested lands under the superseded
 * generation and is invisible to every reader instead of racing the reset.
 *
 * `verdict` carries all three answers including the decline: the entity is the
 * source of truth, and the survey row's `dismissed` status is the materialized
 * consequence of a decline, not its storage.
 *
 * `description` is mandatory exactly when `verdict === 'different'`. The rule is
 * enforced by the endpoint rather than here so the rejection can name the field.
 */ export const StepVariantResponseSchema = z.object({
    _id: z.string(),
    stepRecording: z.string(),
    user: z.string(),
    verdict: VariantCheckAnswerSchema,
    description: z.string().optional(),
    requestGeneration: z.number().int().nonnegative(),
    createdAt: z.string()
});

//# sourceMappingURL=step-variant-response.schema.js.map